<template>
    <MainContentTabs
        :tabs="[
            { tab : 'parcelas', nombre: 'Por parcela' },
            { tab : 'zona', nombre: 'Por zona' }
        ]"
        :atras="false"
        initialTab="parcelas"
    >
        <template slot="parcelas">
            <PreciosParcelas />
        </template>
        <template slot="zona">
            <PreciosParcelasPorZonasComponent />
        </template>
    </MainContentTabs>
</template>

<script>
    import MainContentTabs from '@/components/backend/components/MainContentTabs';
    import PreciosParcelas from '@/components/backend/parcelas/PreciosParcelas';
    import PreciosParcelasPorZonasComponent from '@/components/backend/parcelas/PreciosParcelasPorZonasComponent';

    export default {
        components: {
            MainContentTabs, PreciosParcelas, PreciosParcelasPorZonasComponent
        },
    }
</script>